<template>
  <div>
    <h3>{{ $t('evaluation.evaluation') }}</h3>
    <div id="exportWord">
      <dl class="row">
        <dt class="col-sm-3">{{ $t('recipient') }}</dt>
        <dd class="col-sm-9">{{ recipient.nick_name }}</dd>

        <dt class="col-sm-3">{{ $t('reports.type') }}</dt>
        <dd class="col-sm-9">{{ graphType ? ($t('reports.types.' + reportType) + ' - ' + $t('reports.types.' + graphType)) : $t('reports.types.' + reportType) }}</dd>

        <dt v-if="snapshots.length === 1" class="col-sm-3">{{ $t('title') }}</dt>
        <dd v-if="snapshots.length === 1" class="col-sm-9">{{ snapshots[0].title }}</dd>

        <dt v-if="snapshots.length === 1" class="col-sm-3">{{ $t('reports.last_updated') }}</dt>
        <dd v-if="snapshots.length === 1" class="col-sm-9">{{ snapshots[0].updated_at }}</dd>

        <dt v-if="snapshots.length === 1" class="col-sm-3">{{ $t('reports.creation_time') }}</dt>
        <dd v-if="snapshots.length === 1" class="col-sm-9">{{ snapshots[0].created_at }}</dd>

        <dt class="col-sm-3">{{ $t('evaluation.snapshot.author') }}</dt>
        <dd class="col-sm-9">{{ user.first_name }} {{ user.last_name }}</dd>


      </dl>
    </div>

    <div v-if="reportType === 'satisfaction' && (graphType === 'pies' || graphType === 'stacked_bars')">
      <hr>
      <br>
      <div class="row">
        <div class="col-sm-4"/>
        <div class="col-sm-1 text-center">
          <div id="captionVS">{{ $t('evaluations.head.criteria.very_satisfied') }} </div>
          <canvas id="svgVS" width="40" height="15" style="border:1px solid black; background-color: rgb(216,228,188)"/>
        </div>
        <div class="col-sm-1 text-center">
          <div id="captionS">{{ $t('evaluations.head.criteria.satisfied') }} </div>
          <canvas id="svgS" width="40" height="15" style="border:1px solid black; background-color: rgb(255,255,204)"/>
        </div>
        <div class="col-sm-1 text-center">
          <div id="captionU"> {{ $t('evaluations.head.criteria.unsatisfied') }} </div>
          <canvas id="svgU" width="40" height="15" style="border:1px solid black; background-color: rgb(255,181,108)"/>
        </div>
        <div class="col-sm-1 text-center">
          <div id="captionVU">{{ $t('evaluations.head.criteria.very_unsatisfied') }} </div>
          <canvas id="svgVU" width="40" height="15" style="border:1px solid black; background-color: rgb(237,82,70)"/>
        </div>
        <div class="col-sm-4"/>
      </div>
    </div>
    <br>
    <br>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { isStudent } from '~/plugins/auth'

export default {
  name: 'ReportSnapshotDetails',

  props: {
    recipient: { required: true, type: Object },
    snapshots: { required: false, default: null, type: Array },
    reportType: { required: true, type: String },
    graphType: { required: false, default: null, type: String },
    section: { required: false, default: null, type: String}
  },

  computed: {
    ...mapGetters({
      evaluationsTypes: 'evaluations/evaluations',
      user: 'auth/user'
    })
  },

  methods: {
    isStudent () {
      return isStudent(this.user)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// ../../../../resources/js/components/reports/ReportSnapshotDetails.vue